import { preventIEError } from '@neux/ui-jquery/tool';
import '@neux/ui-jquery/neux-ui-jquery';
import scrollUpShowHeader from './scrollUpShowHeader.js';
import mobileMenu from './mobileMenu.js';

function initializePage() {
}

function main() {
  // init
  preventIEError();
  initializePage();
  // for api
  scrollUpShowHeader();
  mobileMenu();
}

main();